import { render } from "./ComponenteElecPreciosManual.vue?vue&type=template&id=9d5dfbac&scoped=true"
import script from "./ComponenteElecPreciosManual.vue?vue&type=script&lang=js"
export * from "./ComponenteElecPreciosManual.vue?vue&type=script&lang=js"

import "./ComponenteElecPreciosManual.vue?vue&type=style&index=0&id=9d5dfbac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5dfbac"]])

export default __exports__